import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { createContext } from "react";
import { useNavigate } from "react-router-dom";

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [params, setParams] = useState();
  const [paramName, setparamName] = useState();
  const [clickedchat, setClickedChat] = useState(false);
  const [selectedChat, setSelectedChat] = useState();
  const [chats, setChats] = useState([]);
  const [clickedUser, setClickedUser] = useState();
  const [Showpage, setShowpage] = useState(false);
  const [ActionMembers, setActionMembers] = useState({
    DATA: "",
    type: false,
    for: "",
  });
  const [notification, setnotification] = useState([]);
  const [MainLoader, setMainLoader] = useState(0);
  const [PublicLoader, setPublicLoader] = useState(0);
  const[sendingMessage,setSendMessage] = useState()
  const [createPost,setCreatepost] = useState(false)

  const history = useNavigate();
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    setUser(userInfo);
   
  }, [history]);

  return (
    <ChatContext.Provider
      value={{
        user,
        setUser,
        selectedChat,
        setSelectedChat,
        chats,
        setChats,
        ActionMembers,
        setActionMembers,
        MainLoader,
        setMainLoader,
        clickedchat,
        setClickedChat,
        paramName,
        setparamName,
        params,
        setParams,
        clickedUser,
        setClickedUser,
        Showpage,
        setShowpage,
        notification,
        setnotification,
        PublicLoader,
        setPublicLoader,
        sendingMessage,setSendMessage,
        createPost,setCreatepost

      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
